import React, { Fragment } from 'react'
import Spinner from '../../Spinner'
import EmptyRecordIco from '../../icons/EmptyRecordIco'
import {
  CollapseTHElement,
  CollapseTRElement,
  StaticTDElement,
  TableElement,
  TableTDElement,
} from './style'
export default function ExpandableTable({
  columns,
  data,
  collapseCols,
  collapsedData,
  collapsedIndex,
  statusBasedObj,
  statusStaticStatus,
  loading,
  statusProperty,
  statusCheck,
  disabled = false,
  renderExpandContent,
  inEligible = false,
  previewData,
  status,
}) {
  const now = new Date();
  const futureDate = new Date(now?.getTime() + 330 * 60 * 1000);
  return (
    <div
      style={{
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <TableElement>
        <tr>
          {columns?.map((item, index) => {
            return (
              <th
                className="table_head_cell"
                key={index + 'table_head'}
                style={{ paddingLeft: '10px', textAlign: 'left' }}
              >
                {' '}
                {item.title}
              </th>
            )
          })}
        </tr>
        {loading ? (
          <tr>
            <td colSpan={columns?.length} className="ant-table-cell">
              <div className="ant-empty ant-empty-normal">
                <div
                  className="ant-empty-image"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Spinner visible={loading} />
                </div>
              </div>
            </td>
          </tr>
        ) : data?.length === 0 ? (
          <td colSpan={columns?.length} className="ant-table-cell">
            <div className="ant-empty ant-empty-normal">
              <div className="ant-empty-image">
                <EmptyRecordIco />
              </div>
              <div className="ant-empty-description">No data</div>
            </div>
          </td>
        ) : (
          data?.map((row, rowIndex) => (
            <tbody key={rowIndex + 'tbody'}>
              <tr key={rowIndex + 'tablerow'}>
                {columns?.map((col, index) => (
                  <TableTDElement
                    className="table-cell"
                    key={index + 'tableCEll'}
                    style={{ width: 200 }}
                    roleStatus={
                      statusCheck
                        ? new Date(row?.end_date)  >= futureDate 
                          ? 'open'
                          : 'closed'
                        : 'any'
                    }
                    firstIndex={index === 0}
                    lastIndex={rowIndex + 1 === data.length}
                  >
                    {col?.render
                      ? col.render(row[col.dataIndex], row, rowIndex)
                      : row[col.dataIndex]}
                  </TableTDElement>
                ))}
              </tr>
              {collapsedIndex === rowIndex ? (
                <Fragment>
                  {inEligible ? (
                    <tr>
                      <td colSpan={columns?.length}>
                        {renderExpandContent(row , previewData, status)}
                      </td>
                    </tr>
                  ) : collapsedData?.length === 0 ? (
                    <CollapseTRElement color={statusBasedObj('')}>
                      <StaticTDElement
                        colSpan={collapseCols?.length}
                        color={statusBasedObj('')}
                      >
                        {statusStaticStatus}
                      </StaticTDElement>
                    </CollapseTRElement>
                  ) : (
                    <Fragment>
                      <CollapseTHElement
                        status={row?.evaluationStatus}
                        color={statusBasedObj(row?.evaluationStatus)}
                      >
                        {collapseCols?.map((item, index) => (
                          <th key={index + 'td'} className="collapse_th_cell">
                            {item.title}
                          </th>
                        ))}
                      </CollapseTHElement>
                      {collapsedData?.map((collapseRow, innerIndex) => (
                        <CollapseTRElement
                          status={row?.evaluationStatus}
                          color={statusBasedObj(row?.evaluationStatus)}
                          key={innerIndex + 'collapseData'}
                          borderLast={collapsedData?.length - 1 === innerIndex}
                        >
                          {collapseCols?.map((col, index) => {
                            return (
                              <td
                                className="collapse_td_cell"
                                key={index + 'collapse_td_cell'}
                              >
                                {col?.render
                                  ? col.render(
                                      collapseRow[col.dataIndex],
                                      row,
                                      rowIndex,
                                      innerIndex
                                    )
                                  : collapseRow[col.dataIndex]
                                  ? collapseRow[col.dataIndex]
                                  : '-'}
                              </td>
                            )
                          })}
                        </CollapseTRElement>
                      ))}
                    </Fragment>
                  )}
                </Fragment>
              ) : null}
            </tbody>
          ))
        )}
      </TableElement>
    </div>
  )
}
